import { DATES, IN_YEAR, KEY_VALUES, LAYOUT, MONTHS, CARD, JARGON } from "../modules/constants"

/*eslint-disable no-sequences */
Object.filter = (obj, predicate) =>
  Object.keys(obj)
    .filter(key => predicate(obj[key]))
    .reduce((res, key) => (res[key] = obj[key], res), {})
/*eslint-enable no-sequences */

export const cloneDeep = obj => JSON.parse(JSON.stringify(obj))

export const notEmpty = obj => obj && Object.keys(obj).length !== 0

export const removeTitle = string =>
  hasLowerCase(string)
    ? string.replace(/Mr |Ms |Mrs |Miss |Dr |Prof |Professor /gi, '')
    : string

export const hasLowerCase = str => (str ? str.toUpperCase() !== str : str); // don't convert if null

export const getAge = dateOfBirth => {
  if (!dateOfBirth) {
    // console.error("dateOfBirth not known");
    return JARGON.UNKNOWN;
  }

  const today = new Date();
  let years = today.getFullYear() - dateOfBirth.year;
  const months = today.getMonth() - (dateOfBirth.month - 1);
  if (months <= 0)
    years--;

  return years;
}

export const getMonYear = date => {
  var options = { year: 'numeric', month: 'short' }
  return date ? date.toLocaleDateString("en-GB", options) : null
}

export const dobToDate = dob => {
  return dob
    ? dob.month < 10
      ? new Date(`${dob.year}-0${dob.month}`)
      : new Date(`${dob.year}-${dob.month}`)
    : null
}

export const getlinkedInSearchUrl = name => {
  if (name) {
    const nameWords = name.split(" ")
    const firstName = nameWords[0]
    const lastName = nameWords[nameWords.length - 1]
    return `https://www.linkedin.com/search/results/people/?geoUrn=%5B"101165590"%5D&keywords=${firstName}%20${lastName}&origin=SWITCH_SEARCH_VERTICAL`
  }
  else
    return ""
}

export const stringMatch = (stringA, stringB) => stringA.toUpperCase() === stringB.toUpperCase()

/*
export const formatDate = inString => {
  return inString
    ? new Date(inString).toLocaleDateString("en-GB")
    : ""
}
*/

export const isSameDate = (date1, date2) => {
  const d1 = new Date(date1)
  const d2 = new Date(date2)

  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  )
}

// Returns true if the is within n days of the supplied date
export const isWithinNDays = (date, days) => {
  const givenDate = new Date(date);
  const now = new Date();
  const nDaysAgo = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
  return givenDate >= nDaysAgo && givenDate <= now;
}

export const formatDate = (date, showDay) => {
  if (date !== undefined && date !== "" && date !== "0001-01-01T00:00:00") {
    const myDate = new Date(date);
    const month = MONTHS.SHORT[myDate.getMonth()]
    let str = showDay ? myDate.getDate() + " " : ""
    str += month + " " + myDate.getFullYear()
    // if (str === "Jan 1989") str = JARGON.UNKNOWN
    return str
  }
  return JARGON.UNKNOWN
}

export const formatDate_D_MMM_YYYY = date => {
  if (date) {
    const myDate = new Date(date);
    return `${myDate.getDate()} ${MONTHS.SHORT[myDate.getMonth()]} ${myDate.getFullYear()}`
  } else
    return JARGON.UNKNOWN
}

export const formatDate_MMMM_YYYY = date => {
  // Accepts type string or date and returns formated date
  // (eg February 1961) or JARGON.UNKNOWN if null
  if (date) {
    date = typeof date === "string" ? new Date(date) : date
    return `${MONTHS.FULL[date.month - 1]} ${date.year}`
  } else
    return JARGON.UNKNOWN
}

export const formatDate_MMM_YYYY = date => {
  // Accepts type string or date and returns formated date
  // (eg Feb 1961) or JARGON.UNKNOWN if null
  if (date) {
    date = typeof date === "string" ? new Date(date) : date
    return `${MONTHS.SHORT[date.getMonth()]} ${date.getFullYear()}`
  } else
    return JARGON.UNKNOWN
}

// Eg. 2025-06-26T01:00:00Z > "26/06/25"
export const formatShortDate = date => {
  const d = new Date(date)
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'numeric',
    year: '2-digit'
  })
}

export const formatDate_toLocal = date => {
  if (date) {
    date = typeof date === "string" ? new Date(date) : date
    var dateOptions = { day: '2-digit', month: '2-digit', year: '2-digit' }
    var timeOptions = { hour12: false, hour: '2-digit', minute: '2-digit' }
    return date.toLocaleDateString('en-GB', dateOptions) + " " + date.toLocaleTimeString('en-GB', timeOptions)
  } else
    return JARGON.UNKNOWN
}

const dateMultiplier = 10 ** 6
export const getIntDate  = (/** @type {number} */ date) =>  new Date(date * dateMultiplier)

export const formatIntDate_D_MMM_YYYY = date => {
  // Formats a integer date - supplied as (int)((dateTime - new DateTime(1970, 1, 1)).Ticks / 1e10)
  // date is milliseconds since January 1, 1970, 00:00:00 UTC.
  if (date > -1) {
    const myDate = new Date(date * dateMultiplier)
    return `${myDate.getDate()} ${MONTHS.SHORT[myDate.getMonth()]} ${myDate.getFullYear()}`
  } else
    return JARGON.UNKNOWN
}

export const formatIntDate_MMM_YYYY = date => {
  // Formats a integer date - supplied as (int)((dateTime - new DateTime(1970, 1, 1)).Ticks / 1e10)
  // date is milliseconds since January 1, 1970, 00:00:00 UTC.
  if (date > -1) {
    const myDate = new Date(date * dateMultiplier)
    return `${MONTHS.SHORT[myDate.getMonth()]} ${myDate.getFullYear()}`
  } else
    return JARGON.UNKNOWN
}

export const formatIntDate_YYYY_MM_DD = date => {
  // Formats a integer date - supplied as (int)((dateTime - new DateTime(1970, 1, 1)).Ticks / 1e10)
  // date is milliseconds since January 1, 1970, 00:00:00 UTC.
  if (date > -1) {
    const myDate = new Date(date * dateMultiplier)
    return `${myDate.getFullYear()}-${myDate.getMonth()}-${myDate.getDate()}T02:00:00Z`
  } else
    return JARGON.UNKNOWN
}

export const formatInteger = number =>
  number !== null && number !== undefined
    ? Math.round(number).toLocaleString()
    : JARGON.UNKNOWN

export const formatFloat = (number, decimals) =>
  number !== null && number !== undefined && !isNaN(number)
    ? number.toFixed(decimals)
    : JARGON.UNKNOWN


export const monthNameFromNumber = monthNumber => MONTHS.FULL[monthNumber - 1]

export const shortMonthNameFromNumber = monthNumber => MONTHS.SHORT[monthNumber - 1]

export const dateToHoursMinsSecs = date => {
  const hrs = date.getHours()
  const mins = date.getMinutes()
  const secs = date.getSeconds()
  return `${pad(hrs)}:${pad(mins)}:${pad(secs)} `
}

export const millisecsToMinSecs = millisecs => {
  var mins = Math.floor(millisecs / 60000);
  var secs = ((millisecs % 60000) / 1000).toFixed(0);
  return `${mins}:${pad(secs)}`;
}

const pad = num => num < 10 ? "0" + num : num

export const getAgeString = dateOfBirth => {
  return dateOfBirth
    ? `Born: ${monthNameFromNumber(dateOfBirth.month)} ${dateOfBirth.year} - Age: ${getAge(dateOfBirth)}`
    : `Age: ${JARGON.UNKNOWN}`
}

export const getBirthYear = age => {
  var currentDate = new Date()
  var currentYear = currentDate.getFullYear()
  return Math.round(currentYear - age)
}

export const fromDateUnknown = fromDate => {
  if (fromDate && fromDate.getFullYear() === DATES.UNKNOWN_FROM_YEAR &&
    fromDate.getMonth() === DATES.UNKNOWN_FROM_MONTH)
    return true
  else
    return false
}

export const dateStringUnknown = dateString => {
  const date = new Date(dateString)

  if (date && date.getFullYear() === DATES.TIME_START_YEAR &&
    date.getMonth() === DATES.TIME_START_MONTH)
    return true
  else
    return false
}

export const isFarFutureDate = date => {
  if (date && date.getFullYear() === DATES.FUTURE_YEAR)
    return true
  else
    return false
}

export const trimString = (string, maxLength) => {
  let trimmedString = "";

  if (string && string.length > maxLength) {
    //trim the string to the maximum length
    trimmedString = string.slice(0, maxLength);

    //re-trim if we are in the middle of a word
    if (trimmedString.length > trimmedString.lastIndexOf(" ")) {
      trimmedString = trimmedString.slice(0, trimmedString.lastIndexOf(" ")) + "...";
    }
  } else {
    trimmedString = string;
  }

  return trimmedString
}

export const buildTooltipTitle = tooltipElements => {
  let tooltipTitle = "";

  tooltipElements.forEach(element => {
    if (element)
      tooltipTitle += `${element} - `;
  })

  return tooltipTitle;
}

export const isMSEdge = () => {
  // console.log("user agent: " + window.navigator.userAgent);
  return window.navigator.userAgent.indexOf("Edge") > -1;
}

export const isChrome = () => {
  // console.log("user agent: " + window.navigator.userAgent);
  return window.navigator.userAgent.indexOf("Chrome") > -1;
}

export const isSafari = () => {
  // console.log("user agent: " + window.navigator.userAgent);
  const isChrome = navigator.userAgent.indexOf('Chrome') > -1
  let isSafari = navigator.userAgent.indexOf("Safari") > -1
  if (isChrome && isSafari) isSafari = false

  return isSafari
}

export const isNullOrWhiteSpace = str => str === null || str.match(/^ *$/) !== null

export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);

export const isIos = () => /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);

export const isOSX = () => /Mac/i.test(navigator.userAgent) && !isIos()

export const isAndroid = () => /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export const nundefined = value => value === null || value === undefined

/*
export const isIos = () => {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}
*/

export const getCapacities = (connection, childId) => {
  /* eslint-disable no-unused-vars */
  for (const [_, value] of Object.entries(connection)) {
    if (value.childId === childId || value.parentId === childId)
      return {
        officer: value.capacities.officer || [],
        psc: value.capacities.psc || [],
      }
  }
  /* eslint-enable no-unused-vars */
}

export const getNameProp = {
  toSort: nameObj => nameObj?.toSort ?? nameObj?.original?.toUpperCase(),
  toPresent: nameObj => nameObj?.toPresent ?? nameObj?.original?.toUpperCase(),
}

// NB not currently used (only used by PeopleCard etc.)
export const isCurrent = status => {
  // console.log("iC status: ", status);
  const current = status === null || status === JARGON.UNKNOWN || status === "active" || status === "open";
  // console.log("iC current: ", current);
  return current;
}

const statusGood = status => (["active", "open"]).indexOf(status) > -1
// const statusWarn = status => (["active - proposal to strike off", "administration", "receivership", "liquidation"]).indexOf(status) > -1
const statusBad = status => (["dissolved", "closed", "converted-closed", "closed-on"]).indexOf(status) > -1
const statusUnknown = status => !status || ([JARGON.UNKNOWN]).indexOf(status) > -1

export const getStatusLevel = status => {
  status = status ? status.toLowerCase() : null
  return statusUnknown(status)
    ? "UNKNOWN"
    : statusGood(status)
      ? "GOOD"
      : statusBad(status)
        ? "BAD"
        : "WARN"
}

export const getFullStatus = entity => {
  // console.log(`entity: `, entity);
  if (!entity) return JARGON.UNKNOWN;

  const { companyProfile } = entity.companyProps;

  const fullStatus = companyProfile
    ? !companyProfile.companyStatusDetail || companyProfile.companyStatusDetail === "none"
      ? companyProfile.companyStatus
      : `${companyProfile.companyStatus} - ${companyProfile.companyStatusDetail}`
    : entity.companyProps.status ?? JARGON.UNKNOWN;

  return fullStatus
}

export const getFrame = () => {
  const frame = {};
  const app = getElementSize("App");

  if (app.height > app.width) { // portrait mode
    frame.width = app.width
    // NB frame.height is not needed in portrait mode
    frame.portrait = true
  } else { // landscape mode
    frame.width = app.width - (2 * LAYOUT.LANDSCAPE_MENU_WIDTH) - (2 * CARD.MARGIN) - CARD.RADIUS - LAYOUT.SCROLL_BAR_WIDTH

    frame.portrait = false
  }

  // Prefer the real rendered height of the filter sidebar (a stable sibling in the same row as the
  // diagram, sized correctly by flexbox for the actual window/aspect ratio) over the constant
  // arithmetic below, which can drift out of sync with the real layout (e.g. dev-only header content)
  // and let the diagram's SVG grow taller than its card, covering the card's bottom border.
  const menu = getElementSize("nexus-menu")

  frame.height = menu.height || (app.height - KEY_VALUES.NAVBAR_HEIGHT - KEY_VALUES.TABBAR_HEIGHT
    - KEY_VALUES.TITLEBAR_HEIGHT - (2 * CARD.MARGIN) - KEY_VALUES.FOOTER_HEIGHT
    - (2 * LAYOUT.CARD_BORDER_THICKNESS))

  return frame;
}

export const getElementSize = elementId => {
  const size = {};
  const element = document.getElementById(elementId);
  if (element === null) {
    console.error("cannot find element " + elementId);
  }
  else {
    size.width = element.clientWidth;
    size.height = element.clientHeight;
  }
  return size;
}

export const firstCharacterToUpperCase = string => {
  if (string && string.length > 0) {
    const firstCharacter = string.charAt(0).toUpperCase()
    string = firstCharacter + string.slice(1, string.length)
  }

  return string
}

export const capitalise1st = word => word
  ? word.charAt(0).toUpperCase() + word.slice(1)
  : null

export const toTitleCase = string => {
  // remove space before ,
  if (string)
    string = string.replace(" ,", ",")

  // split string into words
  string = string.toLowerCase().split(" ")

  // capitalise first letter of each word
  for (let word = 0; word < string.length; word++)
    string[word] = string[word].charAt(0).toUpperCase() + string[word].slice(1)

  return string.join(" ")
}

//#region Get Address
export const getAddress = address => address
  ? (addCommaAndElementIfNotNull(address.premises)
    + addCommaAndElementIfNotNull(address.addressLine1)
    + addCommaAndElementIfNotNull(address.addressLine2)
    + addCommaAndElementIfNotNull(address.locality)
    + addCommaAndElementIfNotNull(address.county)
    + addCommaAndElementIfNotNull(address.country)
    + addCommaAndElementIfNotNull(address.postalCode)).replace(/(^, )/g, '') // Remove leading ", "
  : JARGON.UNKNOWN

export const getMapAddress = address => address
  ? (addCommaAndElementIfNotNull(address.locality)
    + addCommaAndElementIfNotNull(address.county)
    + addCommaAndElementIfNotNull(address.country)
    + addCommaAndElementIfNotNull(address.postalCode)).replace(/(^, )/g, '') // Remove leading ", "
  : null

const addCommaAndElementIfNotNull = element => element ? `, ${element}` : "";
//#endregion Get Address

//#region deepEqual
// Returns true only is the two objects provided have the same props and values
export const deepEqual = (object1, object2) => {
  // console.log(' (object1, object2):', object1,',', object2)
  const keys1 = Object.keys(object1)
  const keys2 = Object.keys(object2)

  if (keys1.length !== keys2.length)
    return false

  for (const key of keys1) {
    const val1 = object1[key]
    const val2 = object2[key]
    const areObjects = isObject(val1) && isObject(val2)

    if (areObjects && !deepEqual(val1, val2) || !areObjects && val1 !== val2)
      return false
  }

  return true
}

const isObject = (object) => object != null && typeof object === 'object'
//#endregion deepEqual

export const getCheckboxName = (checkbox, bit) => checkbox.find(i => i.BIT === bit).NAME

// Takes a float 'years' and returns a formatted string like
// "2yr 6mo", or just "102yr" if the years exceed 99
export const yearsToString = yearsFloat => {
  if (typeof yearsFloat !== 'number' || yearsFloat < 0)
    return (JARGON.UNKNOWN)

  if (yearsFloat > 99)
    return `${Math.floor(yearsFloat)}yr`

  const years = Math.floor(yearsFloat)
  const months = Math.floor((yearsFloat - years) * 12)
  return `${years}yr ${months}mo`
}

const msecsInMonth = 1000 * 60 * 60 * 24 * 30.4375

// Calculates the difference between two dates (in years and months) and returns a
// formatted string like "3yr 4mo". If the end date is null, it will use today's date:
export const getYearsAndMonths = (startDate, endDate) => {

  if (!startDate) return '?'

  // convert to Date
  const start = new Date(startDate)
  const end = (endDate && endDate != JARGON.FUTURE_DATE) ? new Date(endDate) : new Date()

  // find difference period
  const differenceMonths = Math.round((end - start) / msecsInMonth)
  const diffPositive = Math.abs(differenceMonths)
  const years = Math.floor(diffPositive / 12)
  const months = diffPositive - (years * 12)

  // build result string for display
  let result = differenceMonths >= 0 ? "" : "-"
  if (years > 0) result += `${years}yr`

  if (months >= 0) {
    if (years > 0) result += " "
    result += `${months}mo`
  }

  return result
}

// Calculate the years elapsed between a start and end date
export const yearsElapsed = (start, end) => {
  if (!start || isNaN(new Date(start).valueOf()))
    return 0

  const startDate = new Date(start)
  const endDate = end ? new Date(end) : new Date()

  const elapsedMs = endDate.valueOf() - startDate.valueOf()

  return elapsedMs / IN_YEAR.MILLISECS_IN_YEAR
}

// @ts-ignore
export const normalizeS3Link = (link) =>
  // NB: Some of our links are S3 links which need to be converted to HTTPS links
  link?.startsWith("s3")
    ? link.replace(/^s3/, "https://s3.eu-west-1.amazonaws.com/")
    : link

